<div class="flex h-full flex-col gap-6">
	<div>
		<h1 class="text-3xl font-bold">Admin Dashboard</h1>
		<p class="text-base-content/60 mt-2">Select an admin tool to inspect or manage platform-level resources.</p>
	</div>

	@if (usersRepository.currentProfile(); as currentUser) {
		@if (!currentUser.emailVerified) {
			<div class="alert alert-warning">
				<div class="flex w-full flex-col items-start gap-3 md:flex-row md:items-center md:justify-between">
					<div>
						<div class="font-semibold">Your admin email is not verified yet.</div>
						<div class="text-sm opacity-80">Please verify your email address to unlock features that require a verified account.</div>
					</div>
					<button
						class="btn btn-sm btn-warning"
						[disabled]="isEmailVerificationLoading()"
						(click)="sendEmailVerification()"
					>
						@if (isEmailVerificationLoading()) {
							<span class="loading loading-spinner loading-xs"></span>
						}
						<span [translate]>Send verification email</span>
					</button>
				</div>
			</div>
		}
	}

	<div class="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
		<a routerLink="/admin/translations" class="bg-base-100 border-base-200 hover:border-primary block rounded-xl border p-5 shadow-sm transition-colors">
			<div class="text-lg font-semibold" [translate]>Translations</div>
			<p class="text-base-content/60 mt-2 text-sm">Review and maintain localized content across the platform.</p>
		</a>

		<a routerLink="/admin/tasks" class="bg-base-100 border-base-200 hover:border-primary block rounded-xl border p-5 shadow-sm transition-colors">
			<div class="text-lg font-semibold" [translate]>Tasks</div>
			<p class="text-base-content/60 mt-2 text-sm">Inspect background jobs, processing progress, and retry failed work.</p>
		</a>

		<a routerLink="/admin/emails" class="bg-base-100 border-base-200 hover:border-primary block rounded-xl border p-5 shadow-sm transition-colors">
			<div class="text-lg font-semibold" [translate]>Emails</div>
			<p class="text-base-content/60 mt-2 text-sm">Review recent outgoing emails, inspect delivery attempts, and resend them.</p>
		</a>

		<a routerLink="/admin/users" class="bg-base-100 border-base-200 hover:border-primary block rounded-xl border p-5 shadow-sm transition-colors">
			<div class="text-lg font-semibold" [translate]>Users</div>
			<p class="text-base-content/60 mt-2 text-sm">Manage users and apply account-level admin actions.</p>
		</a>

		<a routerLink="/admin/tickets" class="bg-base-100 border-base-200 hover:border-primary block rounded-xl border p-5 shadow-sm transition-colors">
			<div class="text-lg font-semibold" [translate]>Articles and tickets</div>
			<p class="text-base-content/60 mt-2 text-sm" [translate]>Review public content, support and backlog conversations, visibility, and messages.</p>
		</a>

		<a routerLink="/admin/feedback" class="bg-base-100 border-base-200 hover:border-primary block rounded-xl border p-5 shadow-sm transition-colors">
			<div class="text-lg font-semibold" [translate]>Feedback</div>
			<p class="text-base-content/60 mt-2 text-sm">View all embedded feedback widgets responses and analyze results.</p>
		</a>

		<a routerLink="/admin/assistant-tools" class="bg-base-100 border-base-200 hover:border-primary block rounded-xl border p-5 shadow-sm transition-colors">
			<div class="text-lg font-semibold" [translate]>Assistant Tools</div>
			<p class="text-base-content/60 mt-2 text-sm">Inspect the tools available to the assistant background task via the MCP server.</p>
		</a>

		<a routerLink="/admin/cronjobs" class="bg-base-100 border-base-200 hover:border-primary block rounded-xl border p-5 shadow-sm transition-colors">
			<div class="text-lg font-semibold" [translate]>Cron Jobs</div>
			<p class="text-base-content/60 mt-2 text-sm">View, add, remove, and manually run scheduled cron jobs. Inspect last run output and log files.</p>
		</a>
	</div>
</div>
